export var Roles;
(function (Roles) {
    Roles[Roles["ADMIN"] = 1] = "ADMIN";
    Roles[Roles["MANAGER"] = 2] = "MANAGER";
    Roles[Roles["TUTOR"] = 3] = "TUTOR";
    Roles[Roles["STUDENT"] = 4] = "STUDENT";
})(Roles || (Roles = {}));
